import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import {LandingType, StaticLandingType} from '../../graphql/generated/types';

/**
 * 랜딩 타입별 API 경로 매핑 (StaticLanding 포함)
 *
 * Origin: PageKarinaApi.LANDING_TYPE_API_PATH_MAP
 */
const LANDING_TYPE_API_PATH_MAP: {
  [key in LandingType | StaticLandingType]: () => string;
} = {
  [LandingType.SeriesPoster]: () => '/v1/landing/series/poster',
  [LandingType.SeriesCard]: () => '/v1/landing/series/card',
  [LandingType.SingleList]: () => '/v1/landing/single/list',
  [LandingType.SeriesList]: () => '/v1/landing/series/list',
  [LandingType.SetList]: () => '/v1/landing/set/list',
  [LandingType.SetPoster]: () => '/v1/landing/set/poster',
  [StaticLandingType.TodayNew]: () => '/v1/landing/today_new',
  [StaticLandingType.TodayUp]: () => '/v1/landing/today_up',
  [StaticLandingType.Event]: () => '/v2/landing/event',
  [StaticLandingType.Ranking]: () => '/v1/landing/ranking',
  [StaticLandingType.Genre]: () => '/v1/landing/genre',
  [StaticLandingType.DayOfWeek]: () => '/v2/landing/dayofweek',
  [StaticLandingType.FreeSeries]: () => '/v1/landing/freeseries',
  [StaticLandingType.Original]: () => '/v1/landing/original',
  [StaticLandingType.TodayUpInven]: () => '/v1/landing/today_up_inven',
};

/**
 * 랜딩 조회 (공통, 제네릭)
 *
 * Origin: pageKarinaApi.getLanding
 * API: GET /api/gateway/view/v{version}/landing/{path} (동적)
 *
 * ⚠️ PageKarinaApi.getPath()가 'view' prefix를 자동으로 추가하므로
 *    Fetcher에서는 '/api/gateway/view/...' 형태로 호출해야 함
 */
export async function getLanding<T, P = Record<string, unknown>>(
  landingType: LandingType | StaticLandingType,
  params?: P,
  options?: FetcherOptions
): Promise<ApiResultVo<T>> {
  // 원본 로직: landingType에 따라 API path 결정
  const apiPath = LANDING_TYPE_API_PATH_MAP[landingType]();

  if (!apiPath) {
    throw new Error('카리나 API에 해당 랜딩 타입이 존재하지 않습니다.');
  }

  // ⚠️ PageKarinaApi는 this.getPath(apiPath)로 'view' prefix를 추가
  // → this.getPath('/v2/landing/dayofweek') → 'view/v2/landing/dayofweek'
  // → 따라서 fetcher에서는 '/api/gateway/view/v2/landing/dayofweek'로 호출
  const response = await axiosBffFetch(
    `/api/gateway/view${apiPath}`,
    {
      method: 'GET',
      params: params || {},
    },
    options
  );

  return response.data;
}
